import { styled } from "@mui/material/styles";
import BreakPoints from "src/general/constants/breakPoints";
import Colors from "src/general/constants/colors";

export const Container = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	gap: "24px",
	margin: 0,
	padding: 0,
	[`@media (min-width: ${BreakPoints.TABLET_1023}px) and (max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			gap: "0px",
		},
	[`@media (max-width: ${BreakPoints.TABLET_1023}px)`]: {
		display: "none",
	},
}));

export const Entrance = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	gap: "15px",
	border: `1px solid ${Colors.GREEN}`,
	backgroundColor: Colors.WHITE,
	borderRadius: "32px",
	height: "40px",
	padding: "0 10px",
	cursor: "pointer",
	whiteSpace: "nowrap",
	transition: "background-color 0.3s ease, box-shadow 0.3s ease",
	"&:hover": {
		backgroundColor: Colors.WHITE,
		color: Colors.WHITE,
		boxShadow: `0px 2px 6px ${Colors.GREEN}`,
	},
	svg: {
		minWidth: "initial",
	},
}));

// стиль срабатывает от условия входа в ЛК и подпутей
export const InactiveLink = styled("div")<{ isLkPageOpen?: boolean }>(
	({ isLkPageOpen }) => ({
		pointerEvents: isLkPageOpen ? "none" : "auto",
		cursor: isLkPageOpen ? "not-allowed" : "pointer",
		opacity: isLkPageOpen ? 0.6 : 1,
	})
);

export const Link = styled("a")({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	gap: "15px",
	width: "135px",
	height: "38px",
	cursor: "pointer",
});

export const PhonesWrapper = styled("span") ({
	[`@media (min-width: ${BreakPoints.TABLET_1024}px) and (max-width:1150px)`]: {
		display: "none",
	},
})
